module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/YF5NuZ/tc-custom/9781455609529.jpg?1705213517674",
      "alt": "This image is the cover for the book New Orleans in the Sixties"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("New Orleans in the Sixties\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("In this, her fifth book in the series describing past decades in New Orleans' history, local author and historian Mary Lou Widmer offers readers unique glimpses into the turbulent and triumphal 1960s. ")]), _c('p', [_vm._v("The decade of the sixties was one that confounded America like no period before. It ushered in a time of social change and tension. In New Orleans, this period was visible in the city's skyline as the face of New Orleans began to change. Tourism became a major concern, construction on the Superdome began, some of the biggest buildings were built, and the Saints came marching in.")]), _c('p', [_vm._v("Packed with photographs and reminiscences of an important decade in the evolution of this American metropolis, New Orleans in the Sixties is a unique accomplishment that will interest both residents and lovers of the Crescent City.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Mary Lou Widmer\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("MARY LOU WIDMER, a native of New Orleans, is a certified descendant of the area's settlers prior to the Louisiana Purchase. She is a member of the Louisiana Colonials and the Daughters of 1812.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Pelican Publishing Company\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0